import React, { Component } from "react";
import ReactModal from "react-modal";
import axios from "axios";
import Loader from "react-loader-spinner";
import {apiUrl, apiUrl2, genevent} from "../../config/config";
import "react-dropdown/style.css";
import "./modals.css";
class Addmodaldisclosure extends Component {
  constructor() {
    super();
    this.state = {
      showModal: false,
      showModaldisComplete: false,
      showModalNewdisComplete: false,
      showModaldisSpinnerComplete: false,
      loading: false,
      startProp: "",
      userid: "",
      optionsnewoneand: [],
      optionsnewoneendand: [],
      start_generated: "",
      end_generated: "",
    };
    this.handleCloseModaldisComplete =
      this.handleCloseModaldisComplete.bind(this);
    this.handleCloseModaldisSpinnerNewComplete =
      this.handleCloseModaldisSpinnerNewComplete.bind(this);
    this.handleOpenModaldisSpinnerNewComplete =
      this.handleOpenModaldisSpinnerNewComplete.bind(this);
    this.openGeneratemodalNewdis = this.openGeneratemodalNewdis.bind(this);
  }

  componentDidMount() {
    ReactModal.setAppElement("body");
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.userid !== this.props.userid ||
      prevProps.start !== this.props.start ||
      prevProps.isOpen !== this.props.isOpen
    ) {
      this.setState(
        {
          userid: this.props.userid,
          startProp: this.props.start,
        },
        this.updateOptions
      );
    }
  }

  updateOptions = () => {
    const { treemenu, isOpen } = this.props;
    // console.log(treemenu)
    if (isOpen) {
      let optionnewon = [];
      let optionnewendon = [];
      Object.keys(treemenu).forEach((val) => {
        treemenu[val].forEach((defaultValue) => {
          const MainTimeon = defaultValue.date.split("T");
          const timeon = MainTimeon[1].split("+");
          optionnewon.push(`${val} ${timeon[0]}`);
          optionnewendon.push(`${val} ${timeon[0]}`);
        });
      });

      optionnewon.sort();
      optionnewendon.sort((a, b) => b.localeCompare(a));

      this.setState({
        start_generated: optionnewon[0],
        end_generated: optionnewendon[0],
        optionsnewoneand: optionnewon.map((opt) => (
          <option value={opt} key={opt}>
            {opt}
          </option>
        )),
        optionsnewoneendand: optionnewendon.map((opt) => (
          <option value={opt} key={opt}>
            {opt}
          </option>
        )),
        showModaldisComplete: isOpen,
      });
    }
  };

  onChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
    if (
      e.target.name === "start_generated" ||
      e.target.name === "end_generated"
    ) {
      this.setState({ newName: e.target.value });
    }
  };

  handleCloseModaldisComplete() {
    this.setState({ showModaldisComplete: false });
    this.props.onSelectmodaldis();
  }

  handleCloseModaldisSpinnerNewComplete() {
    this.setState({ showModaldisSpinnerComplete: false });
    this.setState({ showModaldisComplete: true }); // Reopen the main modal once the spinner modal is closed
  }

  handleOpenModaldisSpinnerNewComplete() {
    this.setState({ showModaldisSpinnerComplete: true });
  }

  openGeneratemodalNewdis() {
    this.setState({ showModaldisComplete: false });
    this.handleOpenModaldisSpinnerNewComplete();

    const { userid, start_generated, end_generated } = this.state;
    const [starttime1, starttime2] = start_generated.split(" ");
    const [endtime1, endtime2] = end_generated.split(" ");

    axios
      .post(`${apiUrl}api/common/full_disclosure`, {
        userid,
        starttime1,
        starttime2,
        endtime1,
        endtime2,
      })
      .then((res) => {
        // Generation succeeded — auto-download and close everything.
        this.Download(true);
      })
      .catch((err) => {
        console.error("Full Disclosure generation failed:", err);
        // Close the spinner and reopen the main modal so the user can retry.
        this.handleCloseModaldisSpinnerNewComplete();
      });
  }

  Download = (closeAfter = false) => {
    const { userid } = this.state;
    const downloadUrl = `${apiUrl}api/users/download?userid=${userid}`;

    axios({
      url: downloadUrl,
      method: "GET",
      responseType: "blob",
    })
      .then((response) => {
        const blobUrl = window.URL.createObjectURL(
          new Blob([response.data], { type: "application/pdf" })
        );
        const link = document.createElement("a");
        link.href = blobUrl;
        link.setAttribute("download", `${userid}.pdf`);

        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        // Free the object URL once the browser has started the download.
        setTimeout(() => window.URL.revokeObjectURL(blobUrl), 1000);

        if (closeAfter) {
          // Close both the spinner and the main FD modal — user is done.
          this.setState({
            showModaldisSpinnerComplete: false,
            showModaldisComplete: false,
          });
          if (typeof this.props.onSelectmodaldis === "function") {
            this.props.onSelectmodaldis();
          }
        }
      })
      .catch((err) => {
        console.error("Download Error:", err);
        if (closeAfter) {
          // Auto flow failed — bring the main modal back so user can hit Download.
          this.handleCloseModaldisSpinnerNewComplete();
        }
      });
  };

  render() {
    const customStyles = {
      content: {
        background: "transparent",
        top: "50%",
        left: "50%",
        right: "auto",
        bottom: "auto",
        marginRight: "-50%",
        transform: "translate(-50%, -50%)",
      },
    };

    const customStylesNew = {
      content: {
        top: "38%",
        left: "50%",
        right: "auto",
        bottom: "auto",
        border: "1px solid rgb(204, 204, 204)",
        background: "rgb(255, 255, 255)",
        overflow: "auto",
        borderRadius: "4px",
        outline: "none",
        padding: "20px",
        height: "auto",
        width: "35%",
        marginRight: "-50%",
        transform: "translate(-50%, -50%)",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      },
    };
    const text = "Generating ......";

    return (
      <React.Fragment>
        <ReactModal
          isOpen={this.state.showModaldisSpinnerComplete}
          style={customStylesNew}
          shouldCloseOnOverlayClick={true}
        >
          <div
            style={{ textAlign: "center", padding: "20px", color: "black  " }}
          >
            <Loader type="Puff" color="#00BFFF" height={80} width={80} />
            <div className="bounce-container">
              {text.split("").map((char, index) => (
                <span
                  key={index}
                  className="bounce-letter"
                  style={{ animationDelay: `${index * 0.1}s` }}
                >
                  {char}
                </span>
              ))}
            </div>
          </div>
        </ReactModal>

        <ReactModal
          isOpen={this.state.showModaldisComplete}
          style={customStylesNew}
          contentLabel="Full Disclosure Modal"
          shouldCloseOnOverlayClick={true}
        >
          <div
            className="blog-pop-box"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "stretch",
              background: "#ffffff",
              padding: "0",
              borderRadius: "10px",
              width: "100%",
              overflow: "hidden",
              boxShadow: "0 12px 32px rgba(0,0,0,0.18)",
            }}
          >
            {/* Header bar */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                padding: "14px 20px",
                background:
                  "linear-gradient(135deg, #2ECD99 0%, #25a87c 100%)",
                color: "#ffffff",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  fontSize: "16px",
                  fontWeight: 700,
                  letterSpacing: "0.3px",
                }}
              >
                <span aria-hidden="true" style={{ fontSize: "20px" }}>📄</span>
                Full Disclosure
              </div>
              <button
                className="closeBtn"
                onClick={this.handleCloseModaldisComplete}
                aria-label="Close"
                style={{
                  border: "none",
                  background: "transparent",
                  fontSize: "20px",
                  cursor: "pointer",
                  color: "#ffffff",
                  lineHeight: 1,
                  padding: "4px 6px",
                  borderRadius: "4px",
                }}
              >
                &#10006;
              </button>
            </div>

            <div
              className="fea"
              style={{
                display: "flex",
                flexDirection: "column",
                width: "100%",
                maxWidth: "600px",
                background: "#ffffff",
                padding: "24px 24px 28px",
                borderRadius: "0 0 10px 10px",
              }}
            >
              <p
                style={{
                  color: "#5a6470",
                  fontSize: "13px",
                  margin: "0 0 18px",
                  textAlign: "center",
                }}
              >
                Choose the time range for the disclosure report.
              </p>

              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  gap: "16px",
                  marginBottom: "24px",
                }}
              >
                <div style={{ flex: 1 }}>
                  <label
                    htmlFor="fd_start_time"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                      color: "#2c3e50",
                      fontWeight: 600,
                      fontSize: "13px",
                      marginBottom: "8px",
                    }}
                  >
                    <span aria-hidden="true">🕐</span> Start Time
                  </label>
                  <div style={{ position: "relative" }}>
                    <select
                      id="fd_start_time"
                      name="start_generated"
                      onChange={this.onChange}
                      style={{
                        appearance: "none",
                        WebkitAppearance: "none",
                        MozAppearance: "none",
                        color: "#2c3e50",
                        width: "100%",
                        padding: "10px 36px 10px 12px",
                        borderRadius: "8px",
                        border: "1px solid #d6dde5",
                        backgroundColor: "#f7f9fc",
                        fontSize: "14px",
                        cursor: "pointer",
                        outline: "none",
                        transition: "border-color 0.15s ease, box-shadow 0.15s ease",
                      }}
                      onFocus={(e) => {
                        e.currentTarget.style.borderColor = "#2ECD99";
                        e.currentTarget.style.boxShadow =
                          "0 0 0 3px rgba(46,205,153,0.18)";
                      }}
                      onBlur={(e) => {
                        e.currentTarget.style.borderColor = "#d6dde5";
                        e.currentTarget.style.boxShadow = "none";
                      }}
                    >
                      {this.state.optionsnewoneand}
                    </select>
                    <span
                      aria-hidden="true"
                      style={{
                        position: "absolute",
                        right: "12px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        pointerEvents: "none",
                        color: "#7f8c8d",
                        fontSize: "10px",
                      }}
                    >
                      ▼
                    </span>
                  </div>
                </div>

                <div style={{ flex: 1 }}>
                  <label
                    htmlFor="fd_end_time"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                      color: "#2c3e50",
                      fontWeight: 600,
                      fontSize: "13px",
                      marginBottom: "8px",
                    }}
                  >
                    <span aria-hidden="true">🕓</span> End Time
                  </label>
                  <div style={{ position: "relative" }}>
                    <select
                      id="fd_end_time"
                      name="end_generated"
                      onChange={this.onChange}
                      style={{
                        appearance: "none",
                        WebkitAppearance: "none",
                        MozAppearance: "none",
                        color: "#2c3e50",
                        width: "100%",
                        padding: "10px 36px 10px 12px",
                        borderRadius: "8px",
                        border: "1px solid #d6dde5",
                        backgroundColor: "#f7f9fc",
                        fontSize: "14px",
                        cursor: "pointer",
                        outline: "none",
                        transition: "border-color 0.15s ease, box-shadow 0.15s ease",
                      }}
                      onFocus={(e) => {
                        e.currentTarget.style.borderColor = "#2ECD99";
                        e.currentTarget.style.boxShadow =
                          "0 0 0 3px rgba(46,205,153,0.18)";
                      }}
                      onBlur={(e) => {
                        e.currentTarget.style.borderColor = "#d6dde5";
                        e.currentTarget.style.boxShadow = "none";
                      }}
                    >
                      {this.state.optionsnewoneendand}
                    </select>
                    <span
                      aria-hidden="true"
                      style={{
                        position: "absolute",
                        right: "12px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        pointerEvents: "none",
                        color: "#7f8c8d",
                        fontSize: "10px",
                      }}
                    >
                      ▼
                    </span>
                  </div>
                </div>
              </div>

              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <button
                  onClick={this.openGeneratemodalNewdis}
                  title="Generate the Full Disclosure PDF and download automatically"
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "8px",
                    border: "none",
                    background:
                      "linear-gradient(135deg, #2ECD99 0%, #25a87c 100%)",
                    fontWeight: 600,
                    color: "white",
                    padding: "10px 28px",
                    cursor: "pointer",
                    borderRadius: "24px",
                    fontSize: "14px",
                    letterSpacing: "0.3px",
                    boxShadow: "0 2px 8px rgba(46,205,153,0.4)",
                    transition: "transform 0.15s ease, box-shadow 0.15s ease",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "translateY(-1px)";
                    e.currentTarget.style.boxShadow =
                      "0 4px 12px rgba(46,205,153,0.55)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.boxShadow =
                      "0 2px 8px rgba(46,205,153,0.4)";
                  }}
                >
                  <span aria-hidden="true">⬇</span>
                  Generate &amp; Download
                </button>
              </div>
            </div>
          </div>
        </ReactModal>
      </React.Fragment>
    );
  }
}

export default Addmodaldisclosure;
